// Real FundedLab Data - Complete Prop Firm Programs

export const stats = {
  traders: '45,000+',
  payouts: '$2.6M+',
  instruments: '100+',
  rating: '4.4'
};

// ONE PHASE PROGRAM – FX and CFD
export const onePhaseProgram = [
  {
    id: 'one-phase-5k',
    programType: 'one-phase-fx',
    size: '$5,000',
    cost: '$35',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit', 
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=102',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=109',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=116'
  },
  {
    id: 'one-phase-10k',
    programType: 'one-phase-fx',
    size: '$10,000',
    cost: '$75',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=103',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=110',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=117'
  },
  {
    id: 'one-phase-25k',
    programType: 'one-phase-fx',
    size: '$25,000',
    cost: '$190',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    featured: true, 
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=104',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=111',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=118'
  },
  {
    id: 'one-phase-50k',
    programType: 'one-phase-fx',
    size: '$50,000',
    cost: '$375',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=105',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=112',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=119'
  },
  {
    id: 'one-phase-100k',
    programType: 'one-phase-fx',
    size: '$100,000',
    cost: '$750',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit', 
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=106',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=113',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=120'
  },
  {
    id: 'one-phase-250k',
    programType: 'one-phase-fx',
    size: '$250,000',
    cost: '$2,000',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=107',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=114',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=121'
  },
  {
    id: 'one-phase-400k',
    programType: 'one-phase-fx',
    size: '$400,000',
    cost: '$3,600',
    profitTarget: '10%',
    maxDrawdown: '6%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit', 
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=108',
    linkMTR: 'https://fundedlabdashboard.propaccount.com/challenges?planid=115',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=122'
  }
];

// TWO PHASE PROGRAM – FX and CFD
export const twoPhaseProgram = [
  {
    id: 'two-phase-5k',
    programType: 'two-phase-fx',
    size: '$5,000',
    cost: '$25',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=172',
    linkMTR: 'https://mtr-link-placeholder.com/5k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=186'
  },
  {
    id: 'two-phase-10k',
    programType: 'two-phase-fx',
    size: '$10,000',
    cost: '$50',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=173',
    linkMTR: 'https://mtr-link-placeholder.com/10k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=187'
  },
  {
    id: 'two-phase-25k',
    programType: 'two-phase-fx',
    size: '$25,000',
    cost: '$125',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    featured: true,
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=174',
    linkMTR: 'https://mtr-link-placeholder.com/25k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=188'
  },
  {
    id: 'two-phase-50k',
    programType: 'two-phase-fx',
    size: '$50,000',
    cost: '$225',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=175',
    linkMTR: 'https://mtr-link-placeholder.com/50k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=189'
  },
  {
    id: 'two-phase-100k',
    programType: 'two-phase-fx',
    size: '$100,000',
    cost: '$450',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=176',
    linkMTR: 'https://mtr-link-placeholder.com/100k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=190'
  },
  {
    id: 'two-phase-250k',
    programType: 'two-phase-fx',
    size: '$250,000',
    cost: '$1,250',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=177',
    linkMTR: 'https://mtr-link-placeholder.com/250k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=191'
  },
  {
    id: 'two-phase-400k',
    programType: 'two-phase-fx',
    size: '$400,000',
    cost: '$2,200',
    phase1Target: '8%',
    phase2Target: '5%',
    maxDrawdown: '8%',
    dailyLoss: '5%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=178',
    linkMTR: 'https://mtr-link-placeholder.com/400k-two-phase',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=192'
  }
];

// CRYPTO ONE PHASE
export const cryptoOnePhase = [
  {
    id: 'crypto-one-5k',
    programType: 'crypto-one-phase',
    size: '$5,000',
    cost: '$45',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=232'
    
  },
  {
    id: 'crypto-one-10k',
    programType: 'crypto-one-phase',
    size: '$10,000',
    cost: '$95',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=233'
    
  },
  {
    id: 'crypto-one-25k',
    programType: 'crypto-one-phase',
    size: '$25,000',
    cost: '$250',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    featured: true,
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=234'
   
  },
  {
    id: 'crypto-one-50k',
    programType: 'crypto-one-phase',
    size: '$50,000',
    cost: '$525',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=235'
    
  },
  {
    id: 'crypto-one-100k',
    programType: 'crypto-one-phase',
    size: '$100,000',
    cost: '$1,050',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=236'
    
  },
  {
    id: 'crypto-one-200k',
    programType: 'crypto-one-phase',
    size: '$200,000',
    cost: '$2,150',
    profitTarget: '9%',
    maxDrawdown: '6%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=237'
    
  }
];

// CRYPTO TWO PHASE
export const cryptoTwoPhase = [
  {
    id: 'crypto-two-5k',
    programType: 'crypto-two-phase',
    size: '$5,000',
    cost: '$35',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=226'
  },
  {
    id: 'crypto-two-10k',
    programType: 'crypto-two-phase',
    size: '$10,000',
    cost: '$80',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=227'
  },
  {
    id: 'crypto-two-25k',
    programType: 'crypto-two-phase',
    size: '$25,000',
    cost: '$210',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    featured: true,
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=228'
  },
  {
    id: 'crypto-two-50k',
    programType: 'crypto-two-phase',
    size: '$50,000',
    cost: '$430',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=229'
  },
  {
    id: 'crypto-two-100k',
    programType: 'crypto-two-phase',
    size: '$100,000',
    cost: '$900',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=230'
  },
  {
    id: 'crypto-two-200k',
    programType: 'crypto-two-phase',
    size: '$200,000',
    cost: '$2,000',
    phase1Target: '6%',
    phase2Target: '9%',
    maxDrawdown: '9%',
    dailyCap: '±3%',
    profitSplit: '90%',
    leverage: '5:1 BTC/ETH, 2:1 others',
    inactivity: '30 days',
    maxTime: 'No limit',
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=231'
  }
];

// INSTANT FUNDED – FX and CFD
export const instantFunded = [
  {
    id: 'instant-5k',
    programType: 'instant-funded',
    size: '$5,000',
    cost: '$200',
    profitTarget: 'N/A',
    dailyLoss: '5%',
    maxDrawdown: '8%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    flatWeekend: 'Yes',
    withdrawalMin: 'Greater of 1% or $100',
    addons: {
      weekendHold: '+10%',
      profitSplitUpgrade: '+20%'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=193',
    linkMTR: 'https://mtr-link-placeholder.com/5k-instant',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=203'
  },
  {
    id: 'instant-10k',
    programType: 'instant-funded',
    size: '$10,000',
    cost: '$400',
    profitTarget: 'N/A',
    dailyLoss: '5%',
    maxDrawdown: '8%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    flatWeekend: 'Yes',
    withdrawalMin: 'Greater of 1% or $100',
    addons: {
      weekendHold: '+10%',
      profitSplitUpgrade: '+20%'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=194',
    linkMTR: 'https://mtr-link-placeholder.com/10k-instant',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=204'
  },
  {
    id: 'instant-25k',
    programType: 'instant-funded',
    size: '$25,000',
    cost: '$1,125',
    profitTarget: 'N/A',
    dailyLoss: '5%',
    maxDrawdown: '8%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    flatWeekend: 'Yes',
    withdrawalMin: 'Greater of 1% or $100',
    featured: true,
    addons: {
      weekendHold: '+10%',
      profitSplitUpgrade: '+20%'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=195',
    linkMTR: 'https://mtr-link-placeholder.com/25k-instant',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=205'
  },
  {
    id: 'instant-50k',
    programType: 'instant-funded',
    size: '$50,000',
    cost: '$2,500',
    profitTarget: 'N/A',
    dailyLoss: '5%',
    maxDrawdown: '8%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    flatWeekend: 'Yes',
    withdrawalMin: 'Greater of 1% or $100',
    addons: {
      weekendHold: '+10%',
      profitSplitUpgrade: '+20%'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=196',
    linkMTR: 'https://mtr-link-placeholder.com/50k-instant',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=206'
  },
  {
    id: 'instant-100k',
    programType: 'instant-funded',
    size: '$100,000',
    cost: '$5,000',
    profitTarget: 'N/A',
    dailyLoss: '5%',
    maxDrawdown: '8%',
    profitSplit: '80%',
    leverage: '1:50',
    inactivity: '30 days',
    flatWeekend: 'Yes',
    withdrawalMin: 'Greater of 1% or $100',
    addons: {
      weekendHold: '+10%',
      profitSplitUpgrade: '+20%'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=197',
    linkMTR: 'https://mtr-link-placeholder.com/100k-instant',
    linkCTRADER: 'https://fundedlabdashboard.propaccount.com/challenges?planid=207'
  }
];

// FUTURES PLANS
export const futuresPlans = [
  {
    id: 'futures-25k',
    programType: 'futures',
    size: '$25,000',
    cost: '$265',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '1 standard / 15 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$500',
      phase2: '$750',
      phase3: '$750',
      phase4: '$1,500'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=257'
  },
  {
    id: 'futures-25k-rithmic',
    programType: 'futures',
    size: '$25,000',
    cost: '$265',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '1 standard / 15 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$500',
      phase2: '$750',
      phase3: '$750',
      phase4: '$1,500'
    },
    linkRITHMIC: 'https://fundedlabdashboard.propaccount.com/challenges?planid=238'
  },
  {
    id: 'futures-50k',
    programType: 'futures',
    size: '$50,000',
    cost: '$525',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '3 standard / 30 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    featured: true,
    payoutPhases: {
      phase1: '$1,000',
      phase2: '$1,500',
      phase3: '$1,500',
      phase4: '$3,000'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=261'
  },
  {
    id: 'futures-50k-rithmic',
    programType: 'futures',
    size: '$50,000',
    cost: '$525',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '3 standard / 30 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    featured: true,
    payoutPhases: {
      phase1: '$1,000',
      phase2: '$1,500',
      phase3: '$1,500',
      phase4: '$3,000'
    },
    linkRITHMIC: 'https://fundedlabdashboard.propaccount.com/challenges?planid=242'
  },
  {
    id: 'futures-100k',
    programType: 'futures',
    size: '$100,000',
    cost: '$1,000',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '6 standard / 60 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$2,000',
      phase2: '$3,000',
      phase3: '$3,000',
      phase4: '$6,000'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=265'
  },
  {
    id: 'futures-100k-rithmic',
    programType: 'futures',
    size: '$100,000',
    cost: '$1,000',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '6 standard / 60 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$2,000',
      phase2: '$3,000',
      phase3: '$3,000',
      phase4: '$6,000'
    },
    linkRITHMIC: 'https://fundedlabdashboard.propaccount.com/challenges?planid=246'
  },
  {
    id: 'futures-150k',
    programType: 'futures',
    size: '$150,000',
    cost: '$1,595',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '9 standard / 90 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$3,000',
      phase2: '$4,500',
      phase3: '$4,500',
      phase4: '$9,000'
    },
    link: 'https://fundedlabdashboard.propaccount.com/challenges?planid=269'
  },
  {
    id: 'futures-150k-rithmic',
    programType: 'futures',
    size: '$150,000',
    cost: '$1,595',
    profitTarget: '9%',
    maxLoss: '5%',
    consistency: '25%',
    maxTime: '60 days/phase',
    exposure: '9 standard / 90 micro',
    inactivity: '14 days (phases), 7 days (funded)',
    profitSplit: '90%',
    payoutPhases: {
      phase1: '$3,000',
      phase2: '$4,500',
      phase3: '$4,500',
      phase4: '$9,000'
    },
    linkRITHMIC: 'https://fundedlabdashboard.propaccount.com/challenges?planid=250'
  },
  
];

// Combined challenges for backward compatibility (showing One Phase as default)
export const challenges = onePhaseProgram;

// All programs combined for selection
export const allPrograms = {
  onePhase: onePhaseProgram,
  twoPhase: twoPhaseProgram,
  cryptoOne: cryptoOnePhase,
  cryptoTwo: cryptoTwoPhase,
  instant: instantFunded,
  futures: futuresPlans
};

export const programTypes = [
  { id: 'one-phase-fx', name: 'One Phase FX/CFD', description: '10% profit target, single evaluation phase' },
  { id: 'two-phase-fx', name: 'Two Phase FX/CFD', description: '8% + 5% profit targets, two evaluation phases' },
  { id: 'crypto-one-phase', name: 'Crypto One Phase', description: '9% profit target, crypto trading' },
  { id: 'crypto-two-phase', name: 'Crypto Two Phase', description: '6% + 9% profit targets, crypto trading' },
  { id: 'instant-funded', name: 'Instant Funded', description: 'No evaluation, start trading immediately' },
  { id: 'futures', name: 'Futures', description: '9% profit target per phase, futures trading' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Alex M.',
    review: 'Fastest payouts I\'ve ever experienced. Support team is amazing - 10/10!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  {
    id: 2,
    name: 'Sarah K.',
    review: 'Great platform for serious traders. The instant funding option is a game changer.',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=45'
  },
  {
    id: 3,
    name: 'Michael T.',
    review: 'Been with FundedLab for 6 months. Consistent payouts and excellent support.',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=33'
  },
  {
    id: 4,
    name: 'Emily R.',
    review: 'The scaling plan is incredible. Started with $25k, now trading $100k account!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=47'
  },
  {
    id: 5,
    name: 'David L.',
    review: 'Professional setup, clear rules, and transparent processes. Highly recommend!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=68'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What is the difference between One Phase and Two Phase programs?',
    answer: 'One Phase requires a single 10% profit target to get funded, while Two Phase requires 8% in Phase 1 and 5% in Phase 2. Two Phase programs have lower entry costs.'
  },
  {
    id: 2,
    question: 'How quickly can I withdraw profits?',
    answer: 'For challenge accounts, payouts are processed within 24-48 hours after your withdrawal request. For Instant Funded accounts, first withdrawal anytime, then every 30 days with a minimum of 1% of initial balance or $100, whichever is greater.'
  },
  {
    id: 3,
    question: 'What instruments can I trade?',
    answer: 'Depending on your program: FX/CFD plans cover 100+ forex pairs, indices, and commodities. Crypto plans cover major cryptocurrencies. Futures plans cover standard futures contracts.'
  },
  {
    id: 4,
    question: 'What are the drawdown and risk rules?',
    answer: 'Rules vary by program. FX One Phase: 5% daily loss, 6% max drawdown. FX Two Phase: 5% daily loss, 8% max drawdown. Instant Funded: 5% daily loss, 8% trailing drawdown. Check each program\'s specific rules.'
  },
  {
    id: 5,
    question: 'Can I use EAs or hold overnight trades?',
    answer: 'Yes! You can use Expert Advisors (EAs) and hold trades overnight and over weekends (except Instant Funded without weekend hold add-on). We allow all trading strategies except high-frequency scalping.'
  },
  {
    id: 6,
    question: 'What happens if I breach the rules?',
    answer: 'If you breach any rule (daily loss or max drawdown), your current challenge or funded account will be terminated. You can always purchase a new challenge and try again.'
  },
  {
    id: 7,
    question: 'What are add-ons and how do they work?',
    answer: 'Add-ons are available for Instant Funded FX/CFD accounts: Weekend Hold (+10% cost) allows keeping positions open over weekends, and Profit Split Upgrade (+20% cost) increases your split from 80% to 90%.'
  },
  {
    id: 8,
    question: 'What is the consistency rule for Futures?',
    answer: 'Futures plans require consistency of 25% or less, calculated as: (Best Trading Day PnL ÷ Total PnL) × 100. Example: If your profit target is $8k and your best day is $2k, that\'s 25% (meets rule). If best day is $3k, that\'s 37.5% (violates rule).'
  }
];

export const processSteps = [
  {
    id: 1,
    title: 'Select Your Program',
    description: 'Choose from One Phase, Two Phase, or Instant Funded - FX/CFD, Crypto & Futures programs.',
    icon: 'target'
  },
  {
    id: 2,
    title: 'Complete Evaluation',
    description: 'Meet the profit targets and adhere to the risk parameters, or skip directly to Instant Funded, where no profit targets are imposed.',
    icon: 'trending-up'
  },
  {
    id: 3,
    title: 'Get Funded',
    description: 'Receive your funded account and start trading with our institutional capital.',
    icon: 'check-circle'
  },
  {
    id: 4,
    title: 'Withdraw & Scale',
    description: 'Request payouts and scale your account up to larger capital.',
    icon: 'arrow-up-circle'
  }
];

export const features = [
  {
    id: 1,
    title: 'High Profit Split',
    description: 'Keep up to 90% of your profits depending on your program and add-ons.',
    icon: 'trending-up'
  },
  {
    id: 2,
    title: 'Multiple Program Types',
    description: 'Choose from FX/CFD, Crypto and Futures Challenges, or Instant Funded programs to match your trading style.',
    icon: 'layers'
  },
  {
    id: 3,
    title: 'Fast Payouts',
    description: 'Payouts processed in 24-48 hours after withdrawal request. No delays, no hassles.',
    icon: 'zap'
  },
  {
    id: 4,
    title: 'Global Reach & Support',
    description: 'Traders worldwide, multilingual 24/7 support whenever you need us.',
    icon: 'globe'
  }
];